.root {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 240px;
  background: var(
    --chartv2-background,
    var(--background-default, var(--surface-default, #fcfcfc))
  );
  color: var(--chartv2-foreground, var(--text-default, #202020));
  position: relative;
  box-sizing: border-box;

  /* Token-first; fall back to nort (the app's brand font) then the
   * system stack so the package still looks consistent when consumed
   * without a design-system theme. */
  font-family: var(
    --chartv2-font-family,
    var(
      --font-nort,
      nort,
      -apple-system,
      BlinkMacSystemFont,
      "Segoe UI",
      Roboto,
      sans-serif
    )
  );
}

.body {
  flex: 1 1 auto;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}

.loading {
  width: 100%;
  height: 100%;
  min-height: 240px;
}

.panes {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
}

.pane {
  position: relative;
  min-width: 0;
  overflow: hidden;
}

.paneCollapsed {
  overflow: hidden;
}

.paneCollapsed .legendOverlay {
  inset: 10px 12px 8px 10px;
}

.paneCollapsedXAxis .legendOverlay {
  inset: 10px 12px 40px 10px;
}

.paneMaximized {
  min-height: 0;
}

.paneDivider {
  position: relative;
  flex: 0 0 3px;
  cursor: row-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  touch-action: none;
}

.paneDivider::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: 1px;
  background: var(
    --chartv2-axis-line,
    var(--border-default, rgba(255, 255, 255, 24%))
  );
  transform: translateY(-50%);
  pointer-events: none;
}

.paneDivider:hover::before,
.paneDivider:active::before {
  background: var(
    --chartv2-focus,
    var(--border-hover, rgba(255, 255, 255, 40%))
  );
}

.paneDividerHandle {
  position: relative;
  width: 32px;
  height: 1px;
  border-radius: 1px;
  background: var(--chartv2-axis-label, rgba(255, 255, 255, 32%));
  opacity: 0;
  transition: opacity 120ms ease;
}

.paneDivider:hover .paneDividerHandle,
.paneDivider:active .paneDividerHandle {
  opacity: 1;
}

.legendOverlay {
  position: absolute;
  inset: 10px 12px 16px 10px;
  z-index: 2;
  pointer-events: none;
  min-height: fit-content;
}

.legendOverlay > * {
  pointer-events: auto;
}

.paneActionsOverlay {
  position: absolute;
  top: 6px;
  z-index: 3;
  display: flex;
  gap: 8px;
  pointer-events: none;
}

.paneActionsOverlay > * {
  pointer-events: auto;
}

.paneActions {
  opacity: 0;
  transition: opacity 120ms ease;
  pointer-events: none;
}

/* Invisible pane actions must not swallow chart hover events. */
.pane:hover .paneActions,
.paneMaximized .paneActions,
.paneCollapsed .paneActions {
  opacity: 1;
  pointer-events: auto;
}
